import React from "react";
import { Button, Table, Typography } from "antd";
import newStyled from "@emotion/styled";

const { Title } = Typography;

function NetPromoterTable({ data, onReportClick }) {
  const columns = [
    {
      title: <div style={{ textAlign: "center" }}>Sr. No.</div>,
      dataIndex: "sno",
      key: "sno",
      width: 20,
      align: "center",
    },
    {
      title: <div style={{ textAlign: "left" }}>Store Name</div>,
      dataIndex: "store_name",
      key: "store_name",
      width: 1000,
    },
    {
      title: <div style={{ textAlign: "center" }}>Total Score (Out of 10)</div>,
      dataIndex: "totalScore",
      key: "totalScore",
      align: "center",
      width: 450,
    },
    {
      title: <div style={{ textAlign: "center" }}>Action</div>,
      dataIndex: "action",
      key: "action",
      align: "center",
      width: 300,
      render: (text, record) => (
        <BtnStyle onClick={() => onReportClick(record.auditStoreId)}>
          View
        </BtnStyle>
      ),
    },
  ];

  return (
    <div style={{ marginTop: "20px" }}>
      <Title
        level={3}
        style={{
          textAlign: "start",
          marginBottom: "20px",
          color: "#003d5c",
          fontFamily: "Roboto",
          fontWeight: 500,
        }}
      >
        NPS Score Table:
      </Title>
      <div className="style-table">
        <StyledTable
          columns={columns}
          dataSource={(data || [])
            .filter(
              (item) =>
                item?.totalScore !== null && item?.totalScore !== undefined,
            )
            .map((item, index) => ({
              ...item,
              sno: index + 1,
            }))}
          pagination={false}
          rowClassName={(record, index) =>
            index % 2 === 0 ? "even-row" : "odd-row"
          }
          onRow={(record) => ({
            onClick: () => onReportClick(record.auditStoreId),
          })}
        />
      </div>
    </div>
  );
}

const StyledTable = newStyled(Table)`
  .ant-table-wrapper {
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    overflow: hidden;
  }

  .ant-table-thead > tr > th {
    background:rgb(237 237 237);
    color: #000 !important;
    font-weight: 600 !important;
    font-size: 16px;
    border-bottom: 2px solid #ddd;
    padding: 8px !important;
    font-family:'Roboto', 'sans-serif';
  }
  .ant-table-row.even-row {
    background-color:#ffffff !important;
  }

  .ant-table-row.odd-row {
    background-color: rgb(242,242,242)  !important;
  }
  :where(.ant-table-wrapper) .ant-table .ant-table-tbody > tr > td {
    padding: 8px !important;
  }
`;

const BtnStyle = newStyled(Button)`
  background-color: #007dc1;
  color: #fff;
  border: none !important;
  padding: 8px 15px;
  border-radius: 5px;
  cursor: pointer;
  :where(.css-dev-only-do-not-override-1kf000u).ant-btn-variant-outlined {
    background-color: #007dc1;
  }
  :where(.css-dev-only-do-not-override-1kf000u).ant-btn {
    font-weight: 600 !important;
    font-family: Roboto !important;
  }
`;

export default NetPromoterTable;
